export const EXPLORER_GATEWAY_API_REDUCER_PATH = 'explorerGatewayApi';
